export default __webpack_public_path__ + "static/media/clock.0c163f9b.png";